import React, {Component} from 'react'
import {appDatabasePrimaryFunctions, base} from '../../base';
import '../../styles/css/AnswerButton.css'
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'
import '../../styles/css/ConfirmAlertCustom.css'

import '../../styles/css/CreatorAwards.css'

class UserScreenCreatorAwards extends Component {
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };

    constructor(props) {
        super(props);
        const { cookies } = props;
        this.state = {
            companyList: [],
            companyVotingState: false,
            highlighted: false,
            currentResponse: cookies.get('currentResponse') || 'None',

        };
    }
    componentWillMount() {
      this.companyListState = base.bindToState('companyList', {
          context: this,
          state: 'companyList',
          asArray: true,
      })
      this.ref = base.syncState(`companyVotingOn`, {
        context: this,
        state: 'companyVotingState'
      });
    }

    componentWillUnmount() {
        base.removeBinding(this.companyListState);
        base.removeBinding(this.ref);
    }

    onClickAnswer(passBackVariablesFromClick) {
      if(this.props.connection === false){
        confirmAlert({
            title: 'Poor Connection',
            message: 'Check your connection and try again!',
            confirmLabel: "",
            cancelLabel: 'Okay',
          })
        return;
      }
      if(this.state.currentResponse !== 'None'){
        confirmAlert({
            title: 'Sorry!',
            message: 'We’ve already received your vote!',
            confirmLabel: "",
            cancelLabel: 'Okay',
          })
        return;
      }
      var vm = this;
      confirmAlert({
          title: 'Vote for ' + passBackVariablesFromClick.companyTitle + '?',
          message: 'If you do you will not be able to switch.',
          confirmLabel: 'Okay',
          cancelLabel: 'Cancel',
          onConfirm: () => appDatabasePrimaryFunctions.ref('companyList/' + passBackVariablesFromClick.key + '/votes').transaction(function(data) {
              return data + 1;
          }).then(function() {
            const { cookies } = vm.props;
            cookies.set('currentResponse', passBackVariablesFromClick.key, { path: '/', maxAge:86400 });
            vm.setState({ currentResponse: passBackVariablesFromClick.key});
          }).catch(function(error) {
              confirmAlert({
                  title: 'Whoops!',
                  message: 'Vote failed! Try again.',
                  confirmLabel: 'Okay',
                })
          })
        })
    }

    render() {
      var companyVotingState = this.state.companyVotingState;
      var companyList = this.state.companyList;
        return(
          <div>
          {
            companyVotingState ? (
              <div className="grid-wrapper creatorAwards">
                  <div className="creator-awards-logo user"><img src={require('../../styles/images/creator-awards-logo.png')} alt=""/></div>
                  {/*<div className="grid-header user">
                      <h1>User Vote</h1>
                  </div>*/}
                    <div className="grid-container user" align="center">
                      <div className="hide-desktop" style={{height:'4vh'}}></div>
                        {
                          companyList.map(function(item,i){
                              if(this.state.currentResponse === item.key){
                                return <div
                                          key={i}
                                          className="grid-item"
                                          onClick={()=>this.onClickAnswer(item)}
                                          style={{background: "#000"}}>
                                          <span style={{ marginLeft: 'auto', marginRight: 'auto'}}><strong>{item.companyTitle}</strong></span>
                                        </div>
                              } else {
                              return <div
                                        key={i}
                                        className="grid-item"
                                        onClick={()=>this.onClickAnswer(item)}>
                                        <span style={{ marginLeft: 'auto', marginRight: 'auto'}}>{item.companyTitle}</span>
                                      </div>
                              }
                          }, this)
                        }
                    </div>

                </div>
            ) : (
                <div className="grid-wrapper holding creatorAwards">
                    <div className="grid-container-holding user">
                        <div className="grid-item-holding top-logo">
                            <div className="creator-awards-logo-holding">
                              <img src={require('../../styles/images/creator-awards-logo-holding.png')} alt=""/>
                            </div>
                            <div className="waiting-image-container">
                              <img className="waiting-image" src={require('../../styles/images/waiting-for-vote.png')} alt=""/>
                            </div>
                        </div>
                        <div className="grid-item-holding top-text">
                            {/*<h1 style={{textAlign:"center", paddingTop:'0'}}>Voting is <br /> Coming Up</h1>
                            <h2 className="top-text-mobile user">Live Vote</h2>

                            <h3 className="top-text-mobile waiting">Waiting for vote to begin...</h3>*/}
                        </div>
                        <div className="grid-item-holding middle">
                            <hr className="holding"/>
                        </div>
                    </div>
                </div>
            )
          }
       </div> )
    }
}

export default withCookies(UserScreenCreatorAwards);



// WEBPACK FOOTER //
// ./src/components/creatorawards/UserScreenCreatorAwards.js